import { render, staticRenderFns } from "./AppAuthPage.vue?vue&type=template&id=04b5d10a&scoped=true&"
import script from "./AppAuthPage.vue?vue&type=script&lang=js&"
export * from "./AppAuthPage.vue?vue&type=script&lang=js&"
import style0 from "./AppAuthPage.vue?vue&type=style&index=0&id=04b5d10a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b5d10a",
  null
  
)

export default component.exports